import { styled } from "styled-components";

import { FilterPill, Skeleton } from "@vericus/cadmus-ui";

import { TemplateFilter } from "@/data/templates";

export interface TemplatesFiltersProps {
  activeFilter?: TemplateFilter;
  /** The filters that the user can select from. */
  availableFilters: readonly TemplateFilter[];
  onFilterSelected: (newFilter: TemplateFilter) => void;
}

export const TemplatesFilters = ({
  activeFilter,
  availableFilters,
  onFilterSelected,
}: TemplatesFiltersProps) => {
  return (
    <FilterPill.Root
      type="single"
      value={activeFilter}
      defaultValue="all"
      onValueChange={(value) => {
        if (value) {
          onFilterSelected(value as TemplateFilter);
        }
      }}
      asChild
    >
      <Container>
        {availableFilters.map((filter) => (
          <FilterPill.Item key={filter} value={filter}>
            {formatFilter[filter]}
          </FilterPill.Item>
        ))}
      </Container>
    </FilterPill.Root>
  );
};

const FilterPillSkeleton = styled(Skeleton)`
  border-radius: 100px;
  display: inline;
  height: 36px;
`;

export const TemplatesFiltersSkeleton = ({ filters }: { filters: number }) => {
  const filterSkeletons = Array(filters).fill("_");
  return (
    <Container>
      {filterSkeletons.map((_, index) => (
        <FilterPillSkeleton key={index} width={22} />
      ))}
    </Container>
  );
};

const Container = styled.div`
  padding-left: 8px;
  padding-right: 8px;
  display: flex;
  width: 100%;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
`;

const formatFilter: Record<TemplateFilter, string> = {
  all: "All assessments",
  assignments: "Assignments",
  "formative-tasks": "Formative tasks",
  "timed-assessments": "Timed assessments",
};
